import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IGastoHijoResumen } from 'modelos/src';

/**
 * Tabla del detalle por cliente hijo de un resumen de gastos.
 * Permite buscar (por nombre), paginar y ordenar por cliente y por
 * cantidad de dispositivos (total y por categoría). Solo cantidades.
 */
@Component({
  selector: 'app-detalle-clientes-resumen',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './detalle-clientes-resumen.component.html',
  styleUrl: './detalle-clientes-resumen.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class DetalleClientesResumenComponent implements AfterViewInit {
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatPaginator) paginator?: MatPaginator;

  public dataSource = new MatTableDataSource<IGastoHijoResumen>([]);
  public columnas = ['cliente', 'trackers', 'alarmas', 'camaras', 'total'];

  @Input() set hijos(value: IGastoHijoResumen[] | undefined | null) {
    this.dataSource.data = value ?? [];
  }

  constructor() {
    this.dataSource.sortingDataAccessor = (item, prop) => {
      switch (prop) {
        case 'cliente':
          return (item.nombre || item.idCliente || '').toLowerCase();
        case 'trackers':
          return item.trackers?.cantidad ?? 0;
        case 'alarmas':
          return item.alarmas?.cantidad ?? 0;
        case 'camaras':
          return item.camaras?.cantidad ?? 0;
        default:
          return item.total ?? 0;
      }
    };
    this.dataSource.filterPredicate = (item, filter) =>
      (item.nombre || item.idCliente || '').toLowerCase().includes(filter);
  }

  ngAfterViewInit(): void {
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  public aplicarFiltro(valor: string): void {
    this.dataSource.filter = (valor ?? '').trim().toLowerCase();
    this.dataSource.paginator?.firstPage();
  }
}
